export const {
  REACT_APP_ACCESS_TOKEN_NAME,
  REACT_APP_ACCESS_TOKEN_NAME_MP,
  REACT_APP_API_BASE_BUYER_URL,
  REACT_APP_API_BASE_SELLER_URL,
  REACT_APP_ATTACHMENT_API_URL,
  REACT_APP_ATTACHMENT_LIBRARY,
  REACT_APP_ENVIRONMENT,
  REACT_APP_BUSINESS,
  REACT_APP_ID_BUSINESS,
  REACT_APP_SUB_BUSINESS,
  REACT_APP_FEATURE_FLAG_BUYER_ACTIVITIES_ENABLED,
  REACT_APP_FEATURE_FLAG_DNI_TEST_INPUT_ENABLED,
  REACT_APP_FEATURE_FLAG_FOREIGN_AUTHORITY_ENABLED,
  REACT_APP_FEATURE_FLAG_RECAPTCHA_ENABLED,
  REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN,
  REACT_APP_FEATURE_FLAG_REGISTER_WIZARD,
  REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS,
  REACT_APP_FEATURE_FLAG_TAXES_KEY_ENABLED,
  REACT_APP_FEATURE_FLAG_TAXES_KEY_NATURAL_CHECKS,
  REACT_APP_FEATURE_FLAG_UNIQUE_PASS,
  REACT_APP_GOOGLE_ANALYTICS_KEY = null,
  REACT_APP_GOOGLE_ANALYTICS_SNIPPET_VERSION = null,
  REACT_APP_GOOGLE_TASK_MANAGER_KEY = null,
  REACT_APP_HELP_URL,
  REACT_APP_HOTJAR_ID = null,
  REACT_APP_HOTJAR_SNIPPET_VERSION = null,
  REACT_APP_MERCADO_PUBLICO_BASE_URL,
  REACT_APP_MERCADO_PUBLICO_PROVEEDOR_URL,
  REACT_APP_MERCADO_PUBLICO_COMPRADOR_URL,
  REACT_APP_MERCADO_PUBLICO_LOGIN_PATH,
  REACT_APP_OPTIMIZELY_KEY = null,
  REACT_APP_RECAPTCHA_API_KEY,
  REACT_APP_RECAPTCHA_SITE_KEY,
  REACT_APP_UNIQUE_PASS_APP,
  REACT_APP_UNIQUE_PASS_SEED,
  REACT_APP_TAXES_KEY_SEED,
  REACT_APP_TRAINING_URL,
  REACT_APP_HELP_REPRESENTATIVE_AUTHORITY_URL,
  REACT_APP_AHESION_COVENANT_FILE_URL,
  REACT_APP_UNIQUE_PASS_URL,
  REACT_APP_TERMS_CONDITIONS_URL,
  REACT_APP_SII_URL,
  REACT_APP_SII_TAXES_URL,
  REACT_APP_API_BASE_OCP_URL,
  REACT_APP_HELP_FIRST_STEPS_URL
} = process.env
export const isDevEnv = process.env.REACT_APP_ENVIRONMENT !== 'prod'
export const isLocalEnv = process.env.REACT_APP_ENVIRONMENT === 'local' || process.env.REACT_APP_ENVIRONMENT === 'dev'
export const isProd = process.env.REACT_APP_ENVIRONMENT === 'prod'
